<script lang="ts" setup>
import { Placement } from "element-plus";
import { computed } from "vue";
import {
  CustomEnumDescriptions,
  type EnumDescription,
  enumDescriptions,
} from "~/utils/enumDescriptions";

const props = withDefaults(
  defineProps<{
    modelValue: number | string;
    type: keyof typeof enumDescriptions;
    customEnumDescriptions?: CustomEnumDescriptions;
    hideTooltip?: boolean;
    tooltipPlacement?: Placement;
    size?: "large" | "default" | "small";
  }>(),
  {
    hideTooltip: false,
    tooltipPlacement: "right",
    size: "default",
    customEnumDescriptions: undefined,
  },
);

const description = computed<EnumDescription>(() => {
  const lookup = props.customEnumDescriptions
    ? props.customEnumDescriptions[props.modelValue]
    : enumDescriptions[props.type]?.[props.modelValue];

  // If the value is not found in the enum descriptions, provide a fallback
  if (!lookup) {
    return {
      label:
        typeof props.modelValue === "string"
          ? props.modelValue
          : String(props.modelValue),
      tagType: "info" as const,
      bgColor: undefined,
      fontColor: undefined,
      description: undefined,
    };
  }

  return lookup;
});

const tagStyle = computed(() => ({
  backgroundColor: description.value.bgColor,
  color: description.value.fontColor,
}));
</script>

<template>
  <el-tooltip
    v-if="!hideTooltip && description.description"
    :placement="tooltipPlacement"
  >
    <el-tag :size="size" :type="description.tagType" :style="tagStyle">
      <div>
        {{ description.label }}
      </div>
    </el-tag>
    <template #content>
      <p>
        <b>{{ description.label }}</b> - {{ description.description }}
      </p>
    </template>
  </el-tooltip>
  <el-tag v-else :type="description.tagType" :style="tagStyle">{{
    description.label
  }}</el-tag>
</template>
